import Select from './Select';
import { OptionType } from './Select.types';

export default Select;

export type { OptionType };
